<div
  class="container flex flex-col flex-grow"
  ngClass.lt-md="xs"
  [ngStyle]="getStyle"
>
  <ng-content></ng-content>
</div>

<div class="spacer" [class.fab]="hasFab" [class.chat]="hasChat"></div>
